import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';

export function AboutPage() {
  return <Layout>
    <div className="bg-white rounded-2xl shadow-medium p-8 sm:p-12">
      <Link to="/" className="text-sm text-brand-primario hover:underline">← Volver al inicio</Link>
      <h1 className="text-3xl font-bold text-brand-oscuro mt-4 mb-6">¿Cómo funciona la verificación?</h1>

      <Section title="Open Badges 2.0">
        <p>Las credenciales emitidas por Bootcamp Institute siguen el estándar <strong>Open Badges 2.0</strong> de IMS Global —
        el estándar abierto e interoperable más adoptado para credenciales digitales educativas.</p>
        <p>Cada credencial se compone de 3 documentos JSON-LD:</p>
        <ul>
          <li><strong>Issuer Profile</strong>: identidad pública de Bootcamp Institute como emisor, incluyendo su clave pública RSA-2048.</li>
          <li><strong>BadgeClass</strong>: definición del tipo de credencial (criterios, alineación con frameworks AWS/IMS).</li>
          <li><strong>Assertion</strong>: la instancia específica emitida a un estudiante, firmada vía AWS KMS (RS256).</li>
        </ul>
      </Section>

      <Section title="Cómo verificar programáticamente">
        <p>Cualquier sistema (ATS, LinkedIn, empleador) puede consumir nuestra API pública JSON-LD:</p>
        <pre className="bg-neutral-50 border border-neutral-200 rounded p-4 text-xs overflow-x-auto"><code>{`curl -H "Accept: application/ld+json" \\
  https://verify.bootcamp-institutex.com/api/v1/verify/BG-AWSRESTA-MXMEX30-A1B2C3-D4E5`}</code></pre>
        <p>La respuesta es una Assertion firmada cuyo <code>verification.type=HostedBadge</code> indica que el verificador puede confiar en el documento mientras la URL siga activa y el flag <code>revoked</code> sea <code>false</code>.</p>
      </Section>

      <Section title="Privacidad — Habeas Data">
        <p>La identidad del estudiante (email) se almacena <strong>hasheada con salt único (SHA-256)</strong> en cada Assertion,
        en cumplimiento con LFPDPPP (México) y Ley 1581/2012 (Colombia). El estudiante puede retirar su consentimiento de verificación
        pública en cualquier momento contactando a soporte — la URL devolverá <code>410 Gone</code>.</p>
      </Section>

      <Section title="Revocación">
        <p>Si una credencial fue emitida por error o el portador incurrió en mala conducta, Bootcamp Institute puede revocarla.
        La Assertion permanecerá resoluble (FOSFEC 5 años) pero con <code>revoked: true</code>. La lista canónica de revocaciones
        está disponible en <a href="/api/v1/status-list" className="text-brand-primario hover:underline">/api/v1/status-list</a> bajo el estándar StatusList2021.</p>
      </Section>

      <Section title="Contacto">
        <p>¿Verificas como empleador y tienes dudas? <a href="mailto:verify@bootcamp-institutex.com" className="text-brand-primario hover:underline">verify@bootcamp-institutex.com</a></p>
        <p>¿Eres estudiante y quieres revocar tu consentimiento? <a href="mailto:soporte@bootcamp-institutex.com" className="text-brand-primario hover:underline">soporte@bootcamp-institutex.com</a></p>
      </Section>
    </div>
  </Layout>;
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return <section className="mb-8 prose prose-sm max-w-none prose-headings:text-brand-oscuro prose-strong:text-brand-oscuro prose-code:text-brand-primario prose-code:bg-brand-ligero prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:font-mono prose-code:text-xs">
    <h2 className="text-xl font-semibold text-brand-oscuro mb-3">{title}</h2>
    <div className="space-y-3 text-neutral-700 leading-relaxed">{children}</div>
  </section>;
}
